import { useContext } from 'react';
import {
  SelfServiceCorporateDataContext,
  SelfServiceCorporateDataContextType,
} from 'src/components/selfService/common/SelfServiceCorporateData/SelfServiceCorporateDataContext';

export const useSelfServiceCorporateDataContext =
  (): SelfServiceCorporateDataContextType => {
    const context = useContext(SelfServiceCorporateDataContext);

    if (!context) {
      throw new Error(
        'useSelfServiceCorporateDataContext must be used within a SelfServiceCorporateDataProvider'
      );
    }

    return context;
  };
